import React from 'react'

export interface WarningBoxProps {
  children?: React.ReactNode
}

export default function WarningBox(props: WarningBoxProps) {
  return (
    <div className="w-full max-w-xs flex">
      <div className="p-2 mx-5 my-2 text-sm bg-amber-500 text-white text-left rounded">
        {props.children}
      </div>
    </div>
  )
}
